export default __webpack_public_path__ + "static/media/logout.771b6b40.svg";